import { faPrint } from '@fortawesome/free-solid-svg-icons';
import apiClient from 'api/apiClient';
import LoadingButton from 'components/fantaclasse/LoadingButton';
import React, { useState } from 'react';

const PDFDownloadButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDownload = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await apiClient.get('/bonusMalus/pdf', {
        responseType: 'blob'
      });

      // Get the filename from the Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDisposition);
      const filename =
        matches && matches[1]
          ? matches[1].replace(/['"]/g, '')
          : 'bonus_malus.pdf';

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      setError(err.response?.data?.message || 'Impossibile genera il PDF');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <LoadingButton
        text="Scarica PDF stampabile"
        isLoading={isLoading}
        action={handleDownload}
        variant="falcon-info"
        icon={faPrint}
        className="m-0"
      />
      <br />
      {error && <small className="text-danger mt-2">{error}</small>}
    </>
  );
};

export default PDFDownloadButton;
